import type { PropsWithChildren } from "react";
import { Tippy } from "@circle-react/components/shared/Tippy";

interface TitleItemProps {
  title?: string;
}

export const TitleItem = ({
  children,
  title,
}: PropsWithChildren<TitleItemProps>) => (
  <div>
    {children}
    {title && (
      <span className="flex w-full min-w-0">
        <Tippy content={title} className="truncate text-lg font-semibold">
          {title}
        </Tippy>
      </span>
    )}
  </div>
);
